import React from 'react';
import PropTypes from 'prop-types';
import { Box, Image, Text } from 'components/Wrapped';
import { formatNumberToPlaces } from 'utils';

const PrettyPercent = ({ value, size = 'inherit', sign = '$', weight = 600 }) => {
  const isPositive = Math.sign(value) >= 0;
  // const upArrow = require('assets/icons/up-arrow.svg');
  // const downArrow = require('assets/icons/down-arrow.svg');

  return (
    <Box pad="none" direction="row" align="center" gap="2px">
      {isPositive ? <Image src="/assets/img/icons/up.svg" /> : <Image src="/assets/img/icons/down.svg" />}
      <Text color={isPositive ? '#46B08E' : '#E56150'} size={size} weight={weight}>
        {/* <img
          src={`${isPositive ? upArrow : downArrow}`}
          style={{ marginRight: 10 }}
          alt=""
        /> */}
        {sign}
        {formatNumberToPlaces(value, 2)}%
      </Text>
    </Box>
  );
};

PrettyPercent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default PrettyPercent;
